import React, {useMemo} from 'react';
import translate from '@/utils/translate';
import AutocompleteInput from '@/components/autocomplete-input';
import type {Option} from '@/components/autocomplete-input/AutocompleteInput';
import type {CampaignCreator} from '../../types/campaignCreator';

type CreatorAutocompleteProps = {
  testID?: string;
  campaignCreators: CampaignCreator[];
  selectedCreator: CampaignCreator | null;
  onChange: (creator: CampaignCreator | null) => void;
  openOnFocus?: boolean;
  autoFocus?: boolean;
};

function CreatorAutocomplete({
  testID = 'creator-autocomplete',
  campaignCreators,
  selectedCreator,
  onChange,
  openOnFocus = false,
  autoFocus = false,
}: CreatorAutocompleteProps) {
  const options: Option[] = useMemo(
    () =>
      campaignCreators.map((creator) => ({
        id: creator.id,
        label: creator.name,
      })),
    [campaignCreators]
  );

  const selectedOption: Option | null = selectedCreator
    ? {id: selectedCreator.id, label: selectedCreator.name}
    : null;

  const handleChange = (_: React.SyntheticEvent, value: Option | null) => {
    if (value) {
      const creator = campaignCreators.find(
        (candidate) => candidate.id === value.id
      );
      onChange(creator ?? null);
    } else {
      onChange(null);
    }
  };

  return (
    <AutocompleteInput
      key={selectedCreator?.id ?? 'empty'}
      testID={testID}
      options={options}
      selectedOptions={selectedOption}
      onChange={handleChange}
      placeholder={translate('Search by creator name...')}
      disableCloseOnSelect={false}
      openOnFocus={openOnFocus}
      autoFocus={autoFocus}
    />
  );
}

export default CreatorAutocomplete;
